import React from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
function QuickSearchToolbar() {
    return (
        <Box
            sx={{
                p: 0.5,
                pb: 0,
            }}
        >
            <GridToolbarQuickFilter />
        </Box>
    );
}
export default function VenueDevicesDataMUI(props) {
    console.log("VenueDevicesDataMUI props:", props);
    console.log("deviceData:", props.deviceData);
    console.log("deviceData type:", typeof props.deviceData);
    console.log("deviceData keys:", props.deviceData ? Object.keys(props.deviceData) : "undefined");
    let userAttributes = [];
    let columns = [];
    let rows = [];
    // Create a mapping from UnitID_internal to unit data for quick lookup
    const unitDataMap = {};
    if (props.unitsArrayAll) {
        Object.keys(props.unitsArrayAll).forEach((key) => {
            const unit = props.unitsArrayAll[key];
            const unitIDInternal = unit["UnitID_internal"];
            // Store unit data indexed by UnitID_internal
        });
    }
    // Create a mapping from UnitID_internal to subscription data for email and subscriber token
    const unitSubscriptionMap = {};
    if (props.venueInfo && props.venueInfo["Subscriptions"]) {
        Object.keys(props.venueInfo["Subscriptions"]).forEach((key) => {
            const subscription = props.venueInfo["Subscriptions"][key];
            const unitIDInternal = subscription["UnitID_internal"];
            // Store subscription data indexed by UnitID_internal
            if (!unitSubscriptionMap[unitIDInternal]) {
                unitSubscriptionMap[unitIDInternal] = [];
            }
            unitSubscriptionMap[unitIDInternal].push({
                email: subscription["SubscriberEmail"],
                subscriberToken: subscription["SubscriberToken"],
            });
            unitDataMap[unitIDInternal] = {
                unitID: subscription["UnitID"],
                building: subscription["UnitBuilding"],
                floor: subscription["UnitFloor"],
            };
        });
    }
    if (props.deviceData !== undefined) {
        console.log("Processing deviceData, keys:", Object.keys(props.deviceData));
        for (const key of Object.keys(props.deviceData)) {
            const device = props.deviceData[key];
            console.log(`Processing device ${key}:`, device);
            const unitIDInternal = device["UnitID_internal"];
            // Get unit data from unitsArrayAll
            const unitData = unitDataMap[unitIDInternal] || {};
            // Get subscription data for email and subscriber token
            const subscriptions = unitSubscriptionMap[unitIDInternal] || [];
            const subscription = subscriptions[0] || {}; // Use first subscription if multiple
            // Get device type, map "NetworkDevice" to "Unknown" if it's empty or generic
            const deviceType = device["DeviceType"] || device["deviceType"] || device["Type"] || device["type"] || "";
            const displayType = deviceType.trim() === "" ? "Unknown" : deviceType;
            // Combine unit, building, floor into one display string
            const unitParts = [];
            if (unitData.unitID) unitParts.push(unitData.unitID);
            if (unitData.building) unitParts.push(unitData.building);
            if (unitData.floor) unitParts.push(unitData.floor);
            const unitDisplay = unitParts.length > 0 ? unitParts.join(" / ") : "";
            userAttributes.push({
                id: key,
                status: device["currentlyOnline"],
                type: displayType,
                deviceName: device["UserDefinedHostName"],
                hostName: device["HostName"],
                ipaddress: device["Framed-IP-Address"],
                lastConnected: device["mostRecentUseUTC.ISO8601"],
                email: subscription.email || "",
                unitDisplay: unitDisplay,
                unitID: unitData.unitID || "",
                building: unitData.building || "",
                floor: unitData.floor || "",
                unitIDInternal: unitIDInternal,
                subscriberToken: subscription.subscriberToken || "",
            });
        }
        console.log("Final userAttributes array:", userAttributes);
        console.log("Number of rows created:", userAttributes.length);
    }
    columns = [
        {
            headerName: "Status",
            field: "status",
            minWidth: 100,
            renderCell: (params) =>
                params.value === true ? (
                    <>
                        <div className="active-circle mr-1"></div> Online
                    </>
                ) : (
                    <>
                        <div className="inactive-circle mr-1"></div> Offline
                    </>
                ),
        },
        {
            headerName: "Type",
            field: "type",
            minWidth: 200,
        },
        {
            headerName: "Device Name",
            field: "deviceName",
            minWidth: 200,
        },
        {
            headerName: "Email",
            field: "email",
            minWidth: 200,
        },
        {
            headerName: "Unit / Building / Floor",
            field: "unitDisplay",
            minWidth: 250,
        },
        {
            headerName: "Host Name",
            field: "hostName",
            minWidth: 200,
        },
        {
            headerName: "IP Address",
            field: "ipaddress",
            minWidth: 150,
        },
        {
            headerName: "Last Connected",
            field: "lastConnected",
            type: "date",
            valueFormatter: (value) =>
                value &&
                new Intl.DateTimeFormat("en-US", {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                }).format(new Date(value)),
            minWidth: 180,
        },
    ];
    rows = userAttributes;
    return (
        <div style={{ width: "100%" }}>
            <div style={{ marginBottom: "10px", padding: "10px", backgroundColor: "#f8f9fa", borderRadius: "4px", fontSize: "14px" }}>
                <strong>Tip:</strong> Click on any row to view and modify the subscriber details associated with that device.
            </div>
            <div style={{ height: 400, width: "100%" }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    hideFooterPagination={false}
                    hideFooter={false}
                    getRowHeight={({ id, densityFactor }) => {
                        return 60 * densityFactor;
                    }}
                    slots={{ toolbar: QuickSearchToolbar }}
                    onRowClick={(params) => {
                        if (props.onSubscriberClick && params.row.subscriberToken) {
                            props.onSubscriberClick(params.row.subscriberToken, params.row.email);
                        }
                    }}
                    sx={{
                        '& .MuiDataGrid-row': {
                            cursor: 'pointer',
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: 'rgba(0, 123, 255, 0.08)',
                        },
                    }}
                />
            </div>
        </div>
    );
}
